<template>
  <div id="search-result">
    <div class="search-result-header">
      <h1>{{$_('our_collections')}}</h1>
      <p>{{$_('search_result_text')}}</p>
    </div>
    <transition-group  name="product" tag="div" class="grid-row">
      <div v-for="product in aProduct" :key="product.TMOD" class="c-3 product-container"  @click="goToProduct(product)">
        <Product :productinfo="product" />
      </div>
    </transition-group>
    <div class="pagination-container">
      <Pagination :key="nRender" :nNumeroPage="getNumeroPage" :nNombreElementParPage="getElementParPage" :nNbElementTotal="getNombreEnregistrement" :sTypeElement="$_('articles')" :fn="vLoadProduct"/>
    </div>
  </div>
</template>

<script>

import searchService from '@/modules/recherche/services/searchService'
import Product from '@/modules/produit/components/Product'

import Pagination from '@/common/components/widget/Pagination/Pagination'
import { Bus } from '@/common/Bus';

export default {
    name: 'SearchResult',
    props: {
      product: {
        type: Array()
      }
    },
    data() {
      return {
        aTabProduct: Array(),
        oCritereTemp: Object,
        pagination_info: {
          nNumeroPage: 1,
          nNombreElementParPage: 20,
          nNbRecordData: 0,
        },
        nRender: 0
      }
    },
    components: {
      Product,
      Pagination
    },
    computed: {
      aProduct() {
        return this.aTabProduct
      },
      getResearch() {
        return this.$store.getters['recherche/get_research']
      },
      getElementParPage() {
        return this.pagination_info.nNombreElementParPage;
      },
      getNumeroPage() {
        return this.pagination_info.nNumeroPage;
      },
      getNombreEnregistrement() {
        return this.pagination_info.nNbRecordData;
      }
     },
    created() {

      // let oThis = this;
 
      // window.addEventListener('popstate', function myListener(e) {

      //   let poffset = oThis.$store.getters['recherche/get_poffset'];
      //   let num_page = oThis.$store.getters['recherche/get_num_page'];

      //   oThis.vLoadProduct(num_page, poffset, true);
      //   window.removeEventListener('popstate', myListener);
      // });
      this.vLoadProduct();
    },
    watch: {
      getResearch(val) {
        if(val === true) {

          this.nRender++;

          this.pagination_info.nNumeroPage = 1;
          this.pagination_info.nNombreElementParPage = 20;
      
          this.vLoadProduct();
        }
      },
      product(aProductObject) {

        if(this.$route.query.menu !== undefined) {
          Bus.$emit('openSidebar');
          Bus.$emit('overlay');
        }

        this.aTabProduct = aProductObject
      },
    },
    methods: {
      goToProduct(product) {
        this.$router.push({
          name: 'productpage', 
          query: {
            p: product.TMOD,
            tcatgen: product.TCAT_GEN,
            tcoll: product.TCOLL
          }, 
          params: {
            sProductLibelle: product.TMOD_DESC,
          }
        });
      },
      vLoadProduct(nNumeroPage, nNombreElementParPage, bBack) {

        // console.error('aaaa');

        let poffset = 0;
        let num_page = nNumeroPage;

        if(num_page === undefined) {
          num_page = 0;
        }

        if (num_page > 0) {
          poffset = num_page * nNombreElementParPage
        }

        this.$store.dispatch('recherche/SET', {key: 'poffset', value: poffset});
        this.$store.dispatch('recherche/SET', {key: 'num_page', value: num_page});

        return searchService.getResearch({

          fmotc_typ: this.$store.getters['recherche/get_fmotc_typ'],
          fmotc_mat: this.$store.getters['recherche/get_fmotc_mat'],
          ftyp_offre: this.$store.getters['recherche/get_ftyp_offre'],
          fmotc_cat: this.$store.getters['recherche/get_fmotc_cat'],
          fmotc_cae: this.$store.getters['recherche/get_fmotc_cae'],
          fmotc_caf: this.$store.getters['recherche/get_fmotc_caf'],
          frech_lib: this.$store.getters['recherche/get_frech_lib'],
          fgrp_col: this.$store.getters['recherche/get_fgrp_col'],
          plimit: bBack === true ? nNombreElementParPage : this.pagination_info.nNombreElementParPage,
          poffset

        }).then(res => {

          this.pagination_info.nNbRecordData = res.data.NB_RECORD

          if(this.$store.getters['recherche/get_reset_product_list'] === true) {
            this.aTabProduct = Array();
          }

          res.data.DS_O.OUT.map((product) => {
              this.aTabProduct.push(product)
          })

          this.$store.dispatch('recherche/SELECT', {key: 'launch_research', value: false});
          this.$store.dispatch('recherche/SELECT', {key: 'reset_product_list', value: false});
          this.$store.dispatch('recherche/SET', {key: 'remove_tag_filter', value: false});

          return this.pagination_info;

        }).catch(err => {
          console.error(err)
        });
      }
    }
}
</script>

<style scoped>
#search-result {
  padding: 15px;
}
.search-result-header {
  padding: 0px 15px;
}
.product-enter, .product-leave-to {
  opacity: 0;
  transform: scale(0);
}
.product-enter-to {
  opacity: 1;
  transform: scale(1);
}
.product {
  transition: all 0.5s;
  height: 100%;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
  width: 100%;
}

@media (min-width: 800px) {
  .product {
    padding: 50px 41px 30px 41px;
  }
  div.grid-row .product-container {
    padding: 0;
  }
}

@media (min-width: 1024px) {
  .product {
    padding: 50px 15px 30px 14px;
  }
  .product-container {
    padding: 0px !important;
  }
}

</style>